module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAYCAYAAADzoH0MAAAA3UlEQVQ4T+3UsUpDQRCF4W8aLQKpJI2Fvc8QSG+hfV7AWku1EYKFhUJ6X8LCKi9hY2NlqWlEQRTkjmwIKS4o4V4hFk63zNl/Z2Z3T2gZkZlrOMIuukvyXnCNswK4wMGSG+uyywJ4RK8hYFoAFaIhINsDPu8mlWxRwdt+p8rmLYj38d6KZ7D6W/iv4Bee8p8f4i1e0f/mu89mMMVGTfCEE1xFRJWZQ5xjs6Z7LoBjjOaJD4zLOiKK7y0iMzso2kOszxOnMyfKzAG2cRMRDz+5U2ZuYQf3ETFpamWLM74AQUOAftmJkHoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/score.png
// module id = cMrJ
// module chunks = 1